<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      class="form-input">
      <el-form-item
        :label="$attrs.name"
        :rules="$attrs.props.rules"
        :class="{isRequired: !isRequired}"
        prop="newValue"
        class="item"
      >

        <FileDialog
          v-model="form.newValue"
          width="100%"
          height="100%"
          type="animation"
          preview
        >
          <span
            slot="placeholder"
            class="layout-placeholder"
          >
            选择动画
          </span>
        </FileDialog>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { common } from "../../mixins/common";

  export default {
    name: 'ImSelectAnimation',
    mixins: [common],
  };
</script>

<style scoped>
  .form-input{
    display: flex;
    flex-direction: row;
  }
  .item{
    display: flex;
    flex-direction: row;
    flex: 1;
    margin-bottom: 20px;
  }
  .item >>> .app-qiniu{
    width: 16vw;
    height: 40px;
  }
  .item >>> .iconfont{
    font-size: 22px;
  }
  .isRequired{
    padding-left: 10px;
  }
</style>
